<template>
  <div class="cn-divider" :class="{ 'cn-divider--light': light }" aria-hidden="true">
    <span class="cn-divider__line" />
    <span class="cn-divider__icon">◈</span>
    <span class="cn-divider__line" />
  </div>
</template>

<script>
export default {
  name: 'ChineseDivider',
  props: {
    light: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.cn-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 0;
}
.cn-divider__line {
  flex: 1;
  max-width: 160px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #d4a04a, transparent);
}
.cn-divider__icon {
  font-size: 10px;
  color: #d4a04a;
  line-height: 1;
}
.cn-divider--light .cn-divider__line {
  background: linear-gradient(90deg, transparent, rgba(255, 220, 160, 0.7), transparent);
}
.cn-divider--light .cn-divider__icon {
  color: rgba(255, 220, 160, 0.85);
}
</style>
